import { pipe } from 'fp-ts/function';
import { FC } from 'react';
import { connect } from 'react-redux';
import { ProductPricing } from '@mews-commander/data-access';
import { ApplicationState, Currency } from '@mews-commander/types';
import { getCultureCode } from '@mews-commander/core';
import { getCurrencyLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { getProductPricing } from '@mews-commander/legacy-entities/src/selectors/products';
import { InputField } from '@mews-commander/legacy-form';
import { ProductListProductOwnProps } from '../types';
import { getProductUnitCostFieldName } from '../utils';

interface StateProps {
    currencyLocalizationInfo: Pick<Currency, 'symbol'>;
}

type ProductListProductUnitCostFieldProps = StateProps & ProductListProductOwnProps;

const ProductListProductUnitCostField: FC<ProductListProductUnitCostFieldProps> = ({
    productId,
    hasOverridablePrice,
    currencyLocalizationInfo: { symbol: currencySymbol },
}) => (
    <InputField
        inline
        name={getProductUnitCostFieldName(productId)}
        prefix={currencySymbol}
        inputMode="numeric"
        readOnly={!hasOverridablePrice}
    />
);

export default pipe(
    ProductListProductUnitCostField,
    connect<StateProps, {}, ProductListProductOwnProps, ApplicationState>((state, { productId }) => {
        const productPricing = getProductPricing(state, { id: productId });
        const productCurrency =
            productPricing?.discriminator === ProductPricing.Absolute ? productPricing.value.currency : '';

        return {
            currencyLocalizationInfo: getCurrencyLocalizationInfo(state, {
                currencyCode: productCurrency,
                cultureCode: getCultureCode(),
            }),
        };
    })
);
